// from Figma
export const BAR_COLOR = '#00A3C4';
export const LINE_COLOR = '#C05621';
export const BAR_COLOR_2 = '#B83280';
